import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/goalsApi'
import { patientGet, patientPost, patientPatch } from './patientApi'

const BASE = '/api/secure/me/goals'
const CTX = { requirePatientContext: true }

export async function list(profile, status) {
  if (shouldUseMocks()) return mock.list(profile, status)
  const res = await patientGet(BASE, { ...CTX, params: { status } })
  return res?.data || []
}

export async function create(profile, body) {
  if (shouldUseMocks()) return mock.create(profile, body)
  const res = await patientPost(BASE, body, CTX)
  return res?.data
}

export async function update(profile, id, patch) {
  if (shouldUseMocks()) return mock.update(profile, id, patch)
  const res = await patientPatch(`${BASE}/${encodeURIComponent(id)}`, patch, CTX)
  return res?.data
}

export async function checkIn(profile, id, body) {
  if (shouldUseMocks()) return mock.checkIn(profile, id, body)
  const res = await patientPost(`${BASE}/${encodeURIComponent(id)}/check-in`, body || {}, CTX)
  return res?.data
}
